module.exports = __webpack_public_path__ + "svg/chevron-right-thick.0538a30aecc7c488b283693261d9dece.svg";